import * as z from "zod";

export const getShopifyLocation = {
  name: "getShopifyLocation" as const,
  input: z.object({ locationId: z.string() }),
  output: z.object({
    location: z
      .object({
        id: z.string(),
        name: z.string(),
        address: z.object({
          address1: z.string(),
          address2: z.string().nullish(),
          city: z.string(),
          country: z.string(),
          countryCode: z.string(),
          latitude: z.number().nullish(),
          longitude: z.number().nullish(),
          phone: z.string().nullish(),
          province: z.string().nullish(),
          provinceCode: z.string().nullish(),
          zip: z.string(),
        }),
      })
      .nullish(),
  }),
};
